import { ReactNode } from "react";

import { joinUrl } from "../app/utils/url";
import { UrlPaths } from "../config/const";

/**
 * Lazy Imports sorgt dafür, dass der Code asynchron nachgeladen wird,
 * sodass der Benutzer schneller feedback bekommt, da das Haupt-Bundle
 * eine minimale Größe hat und schneller geladen werden kann.
 *
 * Benutzt Code-Splitting von Webpack
 */
function router(): Promise<{ readonly default: Promise<ReactNode> }> {
	const url = window.location.origin + window.location.pathname;
	if (url === joinUrl(document.baseURI, UrlPaths.pages.fieldInformation)) {
		return import("./fieldInformation");
	}

	return import("./main");
}

export default router().then(async function restructure(module) {
	return { node: await module.default };
});
